// extracted by mini-css-extract-plugin
export default {"block_header":"FeatureValueSelectorsBlock_block_header__a--1t"};